// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Hidden, Link } from "@insite/mobius/index";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LazyImage, { LazyImageProps } from "@store/MobiusOverrides/LazyImage/LazyImage";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import constants from "@store/storeConstants";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export enum PositionValues {
    LeftColumn = "left column",
    MainContent = "main content",
}

const enum fields {
    position = "position",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.position]: PositionValues;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentLanguage: state.context.session.language,
});

type Props = OwnProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnContentStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
    image?: LazyImageProps;
}

export const productListColumnContentStyles: ProductListColumnContentStyles = {
    link: {
        typographyProps: {
            css: css`
                width: 100%;
                display: flex;
                justify-content: center;
            `,
        },
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
        `,
    },
    image: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: auto;
                            height: 100%;
                        `,
                        null,
                        css`
                            width: 100%;
                            height: auto;
                        `,
                        null,
                        null,
                    ],
                    "min",
                )};
        `,
    },
};

const styles = productListColumnContentStyles;

const ProductListColumnContent = ({ category, currentLanguage, fields }: Props) => {
    if (!category || !currentLanguage) {
        return null;
    }
    const { position } = fields;
    const {
        columnContentWidgetPLPImage: columnContentWidgetPLPImage_en,
        columnContentWidgetPLPUrl: columnContentWidgetPLPUrl_en,
        columnContentWidgetPLPImage_fr,
        columnContentWidgetPLPUrl_fr,
    } = category.properties;

    const isFr = currentLanguage?.languageCode === constants.languageCodes.FR_CA;

    const columnContentWidgetPLPImage = isFr ? columnContentWidgetPLPImage_fr : columnContentWidgetPLPImage_en;
    const columnContentWidgetPLPUrl = isFr ? columnContentWidgetPLPUrl_fr : columnContentWidgetPLPUrl_en;

    if (!columnContentWidgetPLPImage && !columnContentWidgetPLPUrl) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {position === PositionValues.MainContent && (
                <Hidden above="sm">
                    <Link href={columnContentWidgetPLPUrl} {...styles.link}>
                        <LazyImage src={columnContentWidgetPLPImage} {...styles.image} />
                    </Link>
                </Hidden>
            )}
            {position === PositionValues.LeftColumn && (
                <Hidden below="md">
                    <Link href={columnContentWidgetPLPUrl} {...styles.link}>
                        <LazyImage src={columnContentWidgetPLPImage} {...styles.image} />
                    </Link>
                </Hidden>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(ProductListColumnContent)),
    definition: {
        group: "Product List",
        displayName: "Column Content",
        allowedContexts: ["ProductListPage", "CategoryDetailsPage", "ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.position,
                editorTemplate: "RadioButtonsField",
                defaultValue: PositionValues.MainContent,
                isRequired: true,
                tooltip: "Select where the widget is displayed (for responsive purpose)",
                options: [
                    {
                        displayName: PositionValues.MainContent,
                        value: PositionValues.MainContent,
                    },
                    {
                        displayName: PositionValues.LeftColumn,
                        value: PositionValues.LeftColumn,
                    },
                ],
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
